import { Container } from "react-bootstrap";
import "./App.css";
import HomePage from "./components/HomePage";
import styles from "./App.module.css";
import { useState, useEffect } from "react";
import { useTheme } from "./ThemeContext";
import NavBarModule from "./NavBarModule";
import FooterModule from "./FooterModule";
import DataCenterPage from "./components/DataCenterPage";
import VirtualServersPage from "./components/VirtualServersPage";
import DedicatedServersPage from "./components/DedicatedServersPage";
import ResourcesPage from "./components/ResourcesPage";
import { Routes, Route, useNavigate } from "react-router-dom";
import PrivacyPage from "./components/PrivacyPage";
import TermsPage from "./components/TermsPage";
import ReferralPage from "./components/ReferralPage";
import { useLocation } from "react-router-dom";
import VirtualHostingPage from "./components/VirtualHostingPage";
import NotFoundPage from "./components/NotFoundPage";

function useWindowWidth() {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return {
    isXs: width < 576,
    isSm: width >= 576 && width < 768,
    isMd: width >= 768 && width < 992,
    isLg: width >= 992 && width < 1200,
    isXl: width >= 1200,
  };
}

function useYandexMetrika() {
  const location = useLocation();
  useEffect(() => {
    if (window.ym) {
      window.ym(95886642, "hit", location.pathname + location.search);
    }
  }, [location]);
}

// const pageMapping = {
//   home: HomePage,
//   dataCenter: DataCenterPage,
//   virtualServers: VirtualServersPage,
//   dedicatedServers: DedicatedServersPage,
//   resources: ResourcesPage,
// };

const pageMapping = {
  home: "",
  dataCenter: "data-center",
  virtualServers: "servers",
  dedicatedServers: "dedicated",
  resources: "brandbook",
  privacy: "privacy",
  terms: "terms",
  referral: "referral",
  virtualHosting: "virtual-hosting",
};

function App() {
  const [isNavOpened, setIsNavOpened] = useState(false);
  const windowSize = useWindowWidth();
  const { s, toggleTheme } = useTheme();
  // const [curPage, setCurPage] = useState("resources");
  const navigate = useNavigate();

  const setCurPage = (page) => {
    console.log(page);
    navigate(`/${pageMapping[page]}`);
  };
  // const Page = pageMapping[curPage];

  useYandexMetrika();
  return (
    <div className="App" style={s.app}>
      <Container fluid>
        <div className={`${styles.landingContainer} pt-3`}>
          <NavBarModule
            setIsOpened={setIsNavOpened}
            isOpened={isNavOpened}
            {...windowSize}
            setCurPage={setCurPage}
          />
          <Routes>
            <Route
              path="/"
              element={
                <HomePage windowSize={windowSize} setCurPage={setCurPage} />
              }
            />
            <Route
              path="/data-center"
              element={
                <DataCenterPage
                  windowSize={windowSize}
                  setCurPage={setCurPage}
                />
              }
            />
            <Route
              path="/servers"
              element={
                <VirtualServersPage
                  windowSize={windowSize}
                  setCurPage={setCurPage}
                />
              }
            />
            <Route
              path="/dedicated"
              element={
                <DedicatedServersPage
                  windowSize={windowSize}
                  setCurPage={setCurPage}
                />
              }
            />
            <Route
              path="/brandbook"
              element={
                <ResourcesPage
                  windowSize={windowSize}
                  setCurPage={setCurPage}
                />
              }
            />
            <Route
              path="/privacy"
              element={
                <PrivacyPage windowSize={windowSize} setCurPage={setCurPage} />
              }
            />
            <Route
              path="/terms"
              element={
                <TermsPage windowSize={windowSize} setCurPage={setCurPage} />
              }
            />
            <Route
              path="/referral"
              element={
                <ReferralPage windowSize={windowSize} setCurPage={setCurPage} />
              }
            />
            <Route
              path="/virtual-hosting"
              element={
                <VirtualHostingPage
                  windowSize={windowSize}
                  setCurPage={setCurPage}
                />
              }
            />
            <Route
              path="*"
              element={
                <NotFoundPage windowSize={windowSize} setCurPage={setCurPage} />
              }
            />
          </Routes>
          {/* <Page windowSize={windowSize} setCurPage={setCurPage} /> */}
          {/* <HomePage windowSize={windowSize} /> */}
          <FooterModule {...windowSize} setCurPage={setCurPage} />
        </div>
      </Container>
    </div>
  );
}

export default App;
